'use client';

import React from 'react';
import Link from 'next/link';
import { cn } from '@/lib/utils';

type UserStatCardProps = {
  label: string;
  value: React.ReactNode;
  icon: React.ComponentType<{ className?: string }>;
  href?: string;
  hint?: string;
  accent?: 'green' | 'mist' | 'amber' | 'rose';
};

const accentMap = {
  green: 'ud-stat-tile--green',
  mist: 'ud-stat-tile--mist',
  amber: 'ud-stat-tile--amber',
  rose: 'ud-stat-tile--rose',
};

export function UserStatCard({ label, value, icon: Icon, href, hint, accent = 'green' }: UserStatCardProps) {
  const inner = (
    <>
      <div className="ud-stat-tile-head">
        <div className="ud-stat-tile-icon">
          <Icon className="w-4 h-4" aria-hidden />
        </div>
        <span className="ud-stat-tile-label">{label}</span>
      </div>
      <span className="ud-stat-tile-value">{value}</span>
      {hint ? <span className="ud-stat-tile-hint">{hint}</span> : null}
    </>
  );

  const className = cn('ud-stat-tile', accentMap[accent]);

  if (href) {
    return (
      <Link href={href} className={className}>
        {inner}
      </Link>
    );
  }

  return <div className={className}>{inner}</div>;
}
